//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import RoundReportRoundCard from '../components/league/round_report_roundCard.vue'
  import {wxShareConfig} from '../js/common/utils'
  import configInfo from "../configInfo.js"
  export default{
        data(){
            return {
              indexContentHeight:0,
              roundInfo:{},
              leagueId:this.$route.query.leagueId,
              roundId: this.$route.query.roundId,
//              leagueBasicInfo:this.$route.query.leagueBasicInfo,
              leagueTitle:this.$route.query.leagueTitle,
              roundTitle:this.$route.query.roundTitle,
              matchCount:0,
              goalCount:0,
              yellowCardCount:0,
              redCardCount:0,
              goalerCount:0,
              mostGoalMatches:[],
              mostGoalCount:0,
              topScorerGoalCount:0,
              topScorers:[]
            }
        },
        mounted(){

          this.loadData(this.leagueId,this.roundId);
          this.$nextTick(() => {
            var height = window.innerHeight;
//            var browerHeadHeight = window.screen.height - window.innerHeight;
            this.indexContentHeight = height;
          })
        },
        methods: {
            initWxShareConfig:function(){
              var fullPath = window.location.href;
              var shareImg = window.location.origin + configInfo.routerBase + "static/logo.png";
              wxShareConfig({
                title: '赛况简报',
                desc: this.leagueTitle+this.roundTitle,
                link: fullPath,
                imgUrl: shareImg,
                type: 'link',
                dataUrl: ''
              }, () => {

              }, () => {

              });
            },
            loadData:function(leagueId, roundId){
              this.hagkHttp(this.hagkApi.getRoundMatches(leagueId, roundId, 0, 0), {})
                .then((res) => {
                  if (res.status == true) {
                      this.roundInfo = res.result.roundVO;
                      this.matchCount = res.result.matchCount;
                      this.goalCount = res.result.goalCount;
                      this.yellowCardCount = res.result.yellowCardCount;
                      this.redCardCount = res.result.redCardCount;
                      this.goalerCount = res.result.goalerCount;
                      this.mostGoalMatches = res.result.mostGoalMatches;
                      this.mostGoalCount = res.result.mostGoalCount;
                      if(this.mostGoalMatches){
                          for(var i =0;i < this.mostGoalMatches.length;i++){
                            this.mostGoalMatches[i].score = this.getScore(this.mostGoalMatches[i]);
                          }
                      }
                      this.topScorerGoalCount = res.result.topScorerGoalCount;
                      this.topScorers = res.result.topScorers;
                  }
                  this.initWxShareConfig();
                }, (error) => {
                  console.log(error);
                  window.alert('本轮赛况获取失败！');
                });
            },
            getScore:function(matchVO){
              var score = '';
              if (matchVO && matchVO.result) {
                var matchObj = matchVO.result;
                var defaultPkScore = (matchObj.homePkScore || matchObj.visitorPkScore) ? "(0)" : "";
                //score += (matchObj.goalFor + matchObj.homeExScore) + (matchObj.homePkScore ? '(' + matchObj.homePkScore + ')' : defaultPkScore)
                //score += "-"
                //score += (matchObj.goalAgainst + matchObj.visitorExScore) + (matchObj.visitorPkScore ? '(' + matchObj.visitorPkScore + ')' : defaultPkScore)
                score += matchObj.goalFor + matchObj.homeExScore + (matchObj.homePkScore ? matchObj.homePkScore : 0);
                score += "-";
                score += matchObj.goalAgainst + matchObj.visitorExScore + (matchObj.visitorPkScore ? matchObj.visitorPkScore : 0);
              } else {
                score = "暂无比分"
              }
              return score
            }
        },
        components: {RoundReportRoundCard}

    }



// WEBPACK FOOTER //
// ./src/views/round_report.vue